import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CloudApiService } from '@/cloud/services/cloud-api.service';
import { FirebaseAuthService } from '@/cloud/services/firebase-auth.service';

@Component({
    selector: 'app-cloud-logout',
    standalone: true,
    template: `
        <div class="flex items-center justify-center min-h-screen">
            <p class="text-center">Signing you out...</p>
        </div>
    `
})
export class CloudLogout {
    private cloud = inject(CloudApiService);
    private firebaseAuth = inject(FirebaseAuthService);
    private router = inject(Router);

    constructor() {
        // Perform logout immediately - sign out of Firebase first
        this.firebaseAuth.signOutFirebase().finally(() => {
            this.cloud.logout();
            // Redirect to root (login guard will show login if not authenticated)
            // Use setTimeout to allow any async local clear/log posts to start
            setTimeout(() => {
                this.router.navigateByUrl('/');
            }, 50);
        });
    }
}
